<template>
  <div class="client-view">
    <HeaderBar :account="account" />

    <div class="content-body">
      <LeftBar :menus="menus" :activeMenu="leftActiveMenu" @select="handleMenu" />

      <div class="center-area">
        <SubHeaderBar
          v-if="!['loggerList', 'accountCreate', 'myPage'].includes(currentMenu)"
          :agencies="agencyList"
          :clients="clientList"
          :selectedAgency="selectedAgency"
          :selectedClient="selectedClient"
          @agency-change="handleAgencyChange"
          @client-change="handleClientChange"
          :config="currentSubHeaderConfig"
        />

        <AllSiteList
          v-if="currentMenu === 'siteList'"
          @detail="openSiteSensorMeasurementManage"
          @create="openCreate"
          @edit="openEdit"
          @category="openCategory"
          @loggerManage="openLoggerSensorManage"
        />

        <SiteCategoryPage
          v-if="currentMenu === 'siteCategory'"
          :siteId="selectedCategorySiteId"
          :siteName="selectedCategorySiteName"
          @back="goSiteList"
        />

        <CreateSiteWizard
          v-if="currentMenu === 'siteCreate'"
          :mode="createMode"
          :siteId="selectedSiteId"
        />

        <SiteSensorMeasurementManage
          v-if="currentMenu === 'siteSensorMeasurementManage'"
          :siteId="selectedMeasurementSiteId"
          :siteName="selectedMeasurementSiteName"
          @back="goSiteList"
        />

        <LoggerList
          v-if="currentMenu === 'loggerList'"
          @sensors="openSensorList"
          @detail="openLoggerDetail"
        />

        <LoggerDetail
          v-if="currentMenu === 'loggerDetail'"
          :loggerId="selectedLoggerId"
          @back="goLoggerList"
          @saved="goLoggerList"
        />

        <SensorList
          v-if="currentMenu === 'sensorList'"
          :sensorLoggerId="selectedLoggerId"
          :loggerName="selectedLoggerName"
          @back="goLoggerList"
          @detail="openSensorDetail"
          @measurements="openSensorMeasurementList"
          @delete="deleteSensor"
        />

        <SensorDetail
          v-if="currentMenu === 'sensorDetail'"
          :sensorId="selectedSensorId"
          @back="goSensorList"
          @saved="goSensorList"
        />

        <SensorMeasurementList
          v-if="currentMenu === 'sensorMeasurementList'"
          :sensorId="selectedSensorId"
          :sensorName="selectedSensorName"
          @back="goSensorList"
        />

        <AccountManagement
          v-if="currentMenu === 'accountManagement'"
          @create="openAccountCreate"
          @edit="openAccountEdit"
        />

        <AccountCreate
          v-if="currentMenu === 'accountCreate'"
          :mode="createMode"
          :form-value="selectedAccount"
          @back="goAccountManagement"
          @saved="goAccountManagement"
        />

        <MyPage v-if="currentMenu === 'myPage'" />

        <EventHistory v-if="currentMenu === 'eventHistory'" />
        <EmergencyNotice v-if="currentMenu === 'emergencyNotice'" />

        <AgencyList
          v-if="currentMenu === 'agencyList'"
          @create="openAgencyCreate"
          @detail="openAgencyDetail"
        />

        <AgencyDetail
          v-if="currentMenu === 'agencyDetail'"
          :agencyId="selectedAgencyId"
          :mode="agencyMode"
          @back="goAgencyList"
          @saved="goAgencyList"
        />

        <ClientList
          v-if="currentMenu === 'clientList'"
          @create="openClientCreate"
          @detail="openClientDetail"
        />

        <ClientDetail
          v-if="currentMenu === 'clientDetail'"
          :clientId="selectedClientManageId"
          :mode="clientMode"
          @back="goClientList"
          @saved="goClientList"
        />

        <MultiSensorManage v-if="currentMenu === 'multiSensorManage'" />

        <LoggerSensorManage v-if="currentMenu === 'loggerSensorManage'" />
        
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '@/components/common/HeaderBar.vue'
import LeftBar from '@/components/common/LeftBar.vue'

import SubHeaderBar from '@/components/admin/SubHeaderBar.vue'
import AllSiteList from '@/components/admin/AllSiteList.vue'
import SiteSensorMeasurementManage from '@/components/admin/SiteSensorMeasurementManage.vue'
import CreateSiteWizard from '@/components/admin/CreateSiteWizard.vue'
import LoggerList from '@/components/admin/LoggerList.vue'
import LoggerDetail from '@/components/admin/LoggerDetail.vue'
import SensorList from '@/components/admin/SensorList.vue'
import SensorDetail from '@/components/admin/SensorDetail.vue'
import SensorMeasurementList from '@/components/admin/SensorMeasurementList.vue'
import AccountManagement from '@/components/admin/AccountManagement.vue'
import AccountCreate from '@/components/admin/AccountCreate.vue'
import EventHistory from '@/components/admin/EventHistory.vue'
import EmergencyNotice from '@/components/admin/EmergencyNotice.vue'
import AgencyList from '@/components/admin/AgencyList.vue'
import AgencyDetail from '@/components/admin/AgencyDetail.vue'
import ClientList from '@/components/admin/ClientList.vue'
import ClientDetail from '@/components/admin/ClientDetail.vue'
import SiteCategoryPage from '@/components/admin/SiteCategoryPage.vue'
import MyPage from '@/components/admin/MyPage.vue'
import MultiSensorManage from '@/components/admin/MultiSensorManage.vue'
import LoggerSensorManage from '@/components/admin/LoggerSensorManage.vue'

import api from '@/api/axios'
import { useAuthStore } from '@/stores/auth'

export default {
  name: 'AdminView',

  components: {
    HeaderBar,
    SubHeaderBar,
    LeftBar,
    AllSiteList,
    SiteSensorMeasurementManage,
    CreateSiteWizard,
    LoggerList,
    LoggerDetail,
    SensorList,
    SensorDetail,
    SensorMeasurementList,
    AccountManagement,
    AccountCreate,
    EventHistory,
    EmergencyNotice,
    AgencyList,
    AgencyDetail,
    ClientList,
    ClientDetail,
    SiteCategoryPage,
    MyPage,
    MultiSensorManage,
    LoggerSensorManage,
  },

  data() {
    return {
      currentMenu: 'siteList',

      selectedLoggerId: null,
      selectedLoggerName: '',
      selectedSensorId: null,
      selectedSensorName: '',

      createMode: 'create',
      selectedSiteId: null,
      selectedAccount: null,

      selectedMeasurementSiteId: null,
      selectedMeasurementSiteName: '',

      agencyList: [],
      clientList: [],

      selectedAgency: null,
      selectedClient: null,

      selectedAgencyId: null,
      selectedClientManageId: null,

      agencyMode: 'create',
      clientMode: 'create',

      selectedCategorySiteId: null,
      selectedCategorySiteName: '',
    }
  },

  computed: {
    authStore() {
      return useAuthStore()
    },

    account() {
      return {
        id: this.authStore.user?.username || '',
        name: this.authStore.user?.roleName || '관리자 시스템',
        mode: 'admin'
      }
    },

    menus() {
      return [
        {
          key: 'siteList',
          label: '현장 리스트',
          icon: 'fa-solid fa-map-location-dot'
        },
        {
          key: 'agencyList',
          label: '대리점 관리',
          icon: 'fa-solid fa-building'
        },
        {
          key: 'clientList',
          label: '발주처 관리',
          icon: 'fa-solid fa-handshake'
        },
        {
          key: 'loggerList',
          label: '로거/센서 관리',
          icon: 'fa-solid fa-satellite-dish'
        },
        {
          key: 'multiSensorManage',
          label: '다단센서 관리',
          icon: 'fa-solid fa-layer-group'
        },
        {
          key: 'eventHistory',
          label: '이벤트 이력',
          icon: 'fa-solid fa-clock-rotate-left'
        },
        {
          key: 'emergencyNotice',
          label: '긴급공지 등록',
          icon: 'fa-solid fa-triangle-exclamation'
        },
        {
          key: 'myPage',
          label: '마이페이지',
          icon: 'fa-solid fa-user'
        },
        {
          key: 'accountManagement',
          label: '전체 계정 관리',
          icon: 'fa-solid fa-users-gear'
        },
        {
          key: 'goClient',
          label: '클라이언트 화면',
          icon: 'fa-solid fa-desktop'
        },
      ]
    },

    currentSubHeaderConfig() {
      return this.currentMenu
    },

    leftActiveMenu() {
      if (['siteList', 'siteCreate', 'siteSensorMeasurementManage', 'siteCategory', 'loggerSensorManage'].includes(this.currentMenu)) {
        return 'siteList'
      }

      if (['agencyList', 'agencyDetail'].includes(this.currentMenu)) {
        return 'agencyList'
      }

      if (['clientList', 'clientDetail'].includes(this.currentMenu)) {
        return 'clientList'
      }

      if (['loggerList', 'loggerDetail', 'sensorList', 'sensorDetail', 'sensorMeasurementList'].includes(this.currentMenu)) {
        return 'loggerList'
      }

      if (['multiSensorManage'].includes(this.currentMenu)) {
        return 'multiSensorManage'
      }

      if (this.currentMenu === 'myPage') {
        return 'myPage'
      }

      if (this.currentMenu === 'goClient') {
        return 'goClient'
      }

      return this.currentMenu
    },
  },

  methods: {
    navigateMenu(menu, extraQuery = {}) {
      const query = {
        menu,
        ...extraQuery,
      }

      this.$router.push({
        path: '/admin',
        query,
      })
    },

    handleMenu(menuKey) {
      if (menuKey === 'goClient') {
        const query = {}

        if (this.selectedMeasurementSiteId) {
          query.id = String(this.selectedMeasurementSiteId)
        } else if (this.selectedSiteId) {
          query.id = String(this.selectedSiteId)
        }

        this.$router.push({
          path: '/client',
          query,
        })
        return
      }

      if (this.currentMenu === 'siteCreate' && menuKey !== 'siteCreate') {
        const ok = window.confirm('현재 진행정보가 모두 사라집니다. 이동하시겠습니까?')
        if (!ok) return
      }

      if (menuKey === 'siteCreate') {
        this.navigateMenu('siteCreate', { mode: 'create' })
        return
      }

      this.navigateMenu(menuKey)
    },

    handleAgencyChange(agency) {
      this.selectedAgency = agency
      console.log('agency changed:', agency?.name)
    },

    handleClientChange(client) {
      this.selectedClient = client
      console.log('client changed:', client?.name)
    },

    openCreate() {
      this.createMode = 'create'
      this.selectedSiteId = null

      this.navigateMenu('siteCreate', {
        mode: 'create',
      })
    },

    openAccountCreate() {
      this.createMode = 'create'
      this.selectedAccount = null

      this.navigateMenu('accountCreate', {
        mode: 'create',
      })
    },

    openAccountEdit(row) {
      this.createMode = 'edit'
      this.selectedAccount = {
        id: row.id,
        accountId: row.accountId,
        role: row.role,
        memo: row.memo,
        agencyId: row.agencyId ?? null,
        agencyName: row.agencyName ?? '',
        clientId: row.clientId ?? null,
        clientName: row.clientName ?? '',
      }

      this.navigateMenu('accountCreate', {
        mode: 'edit',
        accountId: String(row.id),
      })
    },

    openEdit(siteId) {
      this.createMode = 'edit'
      this.selectedSiteId = Number(siteId)

      this.navigateMenu('siteCreate', {
        mode: 'edit',
        siteId: String(siteId),
      })
    },

    onDetail(row) {
      console.log('detail', row)

      const routeData = this.$router.resolve({
        path: '/client',
        query: {
          id: row.id,
        },
      })

      window.open(
        routeData.href,
        '_blank',
        'width=1400,height=900,scrollbars=yes,resizable=yes'
      )
    },

    handleBeforeUnload(e) {
      if (this.currentMenu !== 'siteCreate') return
      e.preventDefault()
      e.returnValue = ''
    },

    openSensorList(row) {
      this.selectedLoggerId = row.id
      this.selectedLoggerName = row.loggerName || ''

      this.navigateMenu('sensorList', {
        loggerId: String(row.id),
        loggerName: row.loggerName || '',
      })
    },

    goLoggerList() {
      this.navigateMenu('loggerList')
    },

    openSensorDetail(row) {
      this.selectedSensorId = row.id

      this.navigateMenu('sensorDetail', {
        loggerId: String(this.selectedLoggerId ?? ''),
        loggerName: this.selectedLoggerName || '',
        sensorId: String(row.id),
      })
    },

    openSensorMeasurementList(row) {
      this.selectedSensorId = row.id
      this.selectedSensorName = row.name || ''

      this.navigateMenu('sensorMeasurementList', {
        loggerId: String(this.selectedLoggerId ?? ''),
        loggerName: this.selectedLoggerName || '',
        sensorId: String(row.id),
        sensorName: row.name || '',
      })
    },

    goSensorList() {
      this.navigateMenu('sensorList', {
        loggerId: String(this.selectedLoggerId ?? ''),
        loggerName: this.selectedLoggerName || '',
      })
    },

    syncMenuFromRoute() {
      const {
        menu,
        mode,
        siteId,
        siteName,
        loggerId,
        loggerName,
        sensorId,
        sensorName,
        agencyId,
        clientId,
      } = this.$route.query

      const validMenus = [
        'siteList',
        'siteCategory',
        'siteSensorMeasurementManage',
        'siteCreate',
        'loggerList',
        'loggerDetail',
        'sensorList',
        'sensorDetail',
        'sensorMeasurementList',
        'multiSensorManage',
        'deviceStatus',
        'eventHistory',
        'emergencyNotice',
        'accountManagement',
        'accountCreate',
        'agencyList',
        'agencyDetail',
        'clientList',
        'clientDetail',
        'myPage',
        'loggerSensorManage',
      ]

      this.currentMenu = validMenus.includes(menu) ? menu : 'siteList'

      this.createMode = mode === 'edit' ? 'edit' : 'create'
      this.selectedSiteId = siteId ? Number(siteId) : null

      this.selectedLoggerId = loggerId ? Number(loggerId) : null
      this.selectedLoggerName = loggerName || ''

      this.selectedSensorId = sensorId ? Number(sensorId) : null
      this.selectedSensorName = sensorName || ''

      this.selectedMeasurementSiteId = siteId ? Number(siteId) : null
      this.selectedMeasurementSiteName = siteName || ''

      this.selectedAgencyId = agencyId ? Number(agencyId) : null
      this.selectedClientManageId = clientId ? Number(clientId) : null

      this.agencyMode = mode === 'edit' ? 'edit' : 'create'
      this.clientMode = mode === 'edit' ? 'edit' : 'create'

      this.selectedCategorySiteId = siteId ? Number(siteId) : null
      this.selectedCategorySiteName = siteName || ''
    },

    openLoggerDetail(row) {
      this.selectedLoggerId = row.id
      this.selectedLoggerName = row.loggerName || ''

      this.navigateMenu('loggerDetail', {
        loggerId: String(row.id),
        loggerName: row.loggerName || '',
      })
    },

    openSiteSensorMeasurementManage(row) {
      this.selectedMeasurementSiteId = row.id
      this.selectedMeasurementSiteName = row.siteName || ''

      this.navigateMenu('siteSensorMeasurementManage', {
        siteId: String(row.id),
        siteName: row.siteName || '',
      })
    },

    goSiteList() {
      this.navigateMenu('siteList')
    },

    openCategory(row) {
      this.selectedCategorySiteId = row.id
      this.selectedCategorySiteName = row.siteName || ''

      this.navigateMenu('siteCategory', {
        siteId: String(row.id),
        siteName: row.siteName || '',
      })
    },

    goAccountManagement() {
      this.navigateMenu('accountManagement')
    },

    openAgencyCreate() {
      this.agencyMode = 'create'
      this.selectedAgencyId = null

      this.navigateMenu('agencyDetail', {
        mode: 'create',
      })
    },

    openAgencyDetail(row) {
      this.agencyMode = 'edit'
      this.selectedAgencyId = row.id

      this.navigateMenu('agencyDetail', {
        mode: 'edit',
        agencyId: String(row.id),
      })
    },

    goAgencyList() {
      this.navigateMenu('agencyList')
    },

    openClientCreate() {
      this.clientMode = 'create'
      this.selectedClientManageId = null

      this.navigateMenu('clientDetail', {
        mode: 'create',
      })
    },

    openClientDetail(row) {
      this.clientMode = 'edit'
      this.selectedClientManageId = row.id

      this.navigateMenu('clientDetail', {
        mode: 'edit',
        clientId: String(row.id),
      })
    },

    goClientList() {
      this.navigateMenu('clientList')
    },

    async fetchAgencyListForHeader() {
      try {
        const response = await api.get('/app/agency/list', {
          params: {
            page: 0,
            size: 999,
            orderBy: 'nameAsc',
          },
        })

        const rows = response.data?.result?.content ?? []

        this.agencyList = rows.map(item => ({
          id: item.id,
          name: item.name,
        }))
      } catch (error) {
        console.error('대리점 목록 조회 실패', error)
        this.agencyList = []
      }
    },

    async fetchClientListForHeader() {
      try {
        const response = await api.get('/app/client/list', {
          params: {
            page: 0,
            size: 999,
            orderBy: 'nameAsc',
          },
        })

        const rows = response.data?.result?.content ?? []

        this.clientList = rows.map(item => ({
          id: item.id,
          name: item.name,
        }))
      } catch (error) {
        console.error('발주처 목록 조회 실패', error)
        this.clientList = []
      }
    },

    deleteSensor(row) {
      console.log('sensor delete', row)
    },

    openLoggerSensorManage(row) {
      this.navigateMenu('loggerSensorManage', {
        siteId: String(row.id),
        siteName: row.siteName || '',
      })
    },
  },

  watch: {
    currentMenu(newVal, oldVal) {
      console.log('currentMenu changed', oldVal, '->', newVal)
      console.trace('menu change trace')
    },

    '$route.query': {
      deep: true,
      handler() {
        this.syncMenuFromRoute()
      }
    }
  },

  async mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload)
    this.syncMenuFromRoute()
    await this.fetchAgencyListForHeader()
    await this.fetchClientListForHeader()
  },

  beforeUnmount() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  },
}
</script>

<style>
.content-body {
  padding: 5px 30px;
  display: flex;
  height: calc(100vh - 100px);
  gap: 20px;
}

.content-body > .left-bar {
  width: 240px;
  flex-shrink: 0;
}

.center-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}

.SubHeaderBar {
  flex-shrink: 0;
}
</style>